import { render, staticRenderFns } from "./LotteryEventDetails.vue?vue&type=template&id=cf8b6f2a&"
import script from "./LotteryEventDetails.vue?vue&type=script&lang=js&"
export * from "./LotteryEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./LotteryEventDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports